import { EventTrackTypes, SubscribeFromTypes } from '../../../constants/EventTracks';
import { useCaptureEvents } from '../../../hooks/useCaptureEvents';
import { AppActionType } from '../context/appContext/actions';
import { useAppContext } from '../context/appContext/context';

interface UseUpgradeDialogVisibilityResponse {
  visible: boolean;
  setDialogVisibility: (visible: boolean, source?: SubscribeFromTypes) => void;
}

export const useUpgradeDialogVisibility = (): UseUpgradeDialogVisibilityResponse => {
  const { appState, appDispatch } = useAppContext();
  const { capture } = useCaptureEvents();

  const setDialogVisibility = (visible: boolean, source?: SubscribeFromTypes) => {
    if (visible) {
      capture({
        type: EventTrackTypes.Subscribe,
        payload: {
          [`Action`]: `Open`,
          [`From`]: source ?? `Exceeding limits`,
        },
      });
    }
    appDispatch({
      type: AppActionType.SET_UPGRADE_DIALOG_VISIBLE,
      payload: visible,
    });
  };

  return {
    visible: appState.upgradeDialogVisible,
    setDialogVisibility,
  };
};
